import { create } from 'zustand';

interface UIStore {
  // Citations Manager Panel
  citationsManagerOpen: boolean;
  citationsManagerProjectId: string | null;
  editingCitationId: string | null;
  
  // Focus Writing Mode - global state to survive remounts
  activeFocusSectionId: string | null;
  focusModeData: {
    chapterId: string;
    projectId?: string;
    citationStyle?: string;
    researchItems?: any[];
    manuscriptType?: string;
    chapterTitle?: string;
    chapterSummary?: string;
  } | null;
  
  openCitationsManager: (projectId: string) => void;
  closeCitationsManager: () => void;
  toggleCitationsManager: (projectId?: string) => void;
  setEditingCitation: (citationId: string | null) => void;
  
  // Focus Mode actions
  openFocusMode: (sectionId: string, data: NonNullable<UIStore['focusModeData']>) => void;
  closeFocusMode: () => void;
}

export const useUIStore = create<UIStore>((set, get) => ({
  citationsManagerOpen: false,
  citationsManagerProjectId: null,
  editingCitationId: null,
  activeFocusSectionId: null,
  focusModeData: null,
  
  openCitationsManager: (projectId: string) => set({ 
    citationsManagerOpen: true, 
    citationsManagerProjectId: projectId 
  }),
  
  closeCitationsManager: () => set({ 
    citationsManagerOpen: false,
    editingCitationId: null,
  }),
  
  toggleCitationsManager: (projectId?: string) => {
    const { citationsManagerOpen, citationsManagerProjectId } = get();
    if (citationsManagerOpen) {
      set({ citationsManagerOpen: false, editingCitationId: null });
    } else if (projectId || citationsManagerProjectId) {
      set({ 
        citationsManagerOpen: true, 
        citationsManagerProjectId: projectId || citationsManagerProjectId 
      });
    }
  },
  
  setEditingCitation: (citationId: string | null) => set({ editingCitationId: citationId }),
  
  openFocusMode: (sectionId, data) => set({ 
    activeFocusSectionId: sectionId,
    focusModeData: data,
  }),
  
  closeFocusMode: () => set({ 
    activeFocusSectionId: null,
    focusModeData: null,
  }),
}));
